import React, { useState } from "react";
import { TextField } from "@mui/material";
import { Button, Switch } from "antd";
import { TfiReload } from "react-icons/tfi";
import { MdEdit } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import { subcategoryUpdate } from "../../../redux/Subcategory/SubcategorySlice";
import { Link, useNavigate } from "react-router-dom";

const SubcategoryList = () => {
  const { sub_category_all } = useSelector((store) => store.subcategory);
  console.log(sub_category_all,"sub_category_all");
  
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const statusChange = async (checked, data) => {
    if (data) {
      const formData = {
        subcatId: data._id,
        status: checked,
      };
      const updateCat = await dispatch(subcategoryUpdate(formData));
    }
  };
  return (
    <>
      <div className="page_header">
        <h4>Sub-Categories</h4>
      </div>

      <div className="cat_list_header">
        <div className="cat_search_box">
          <TextField
            id="custom-input"
            placeholder="search"
            variant="outlined"
            autocomplete="off"
            size="small"
            className="input_container"
            InputProps={{
              style: {
                // backgroundColor: "#ffe6e6",
                // border: "1px solid red",
              },
            }}
            FormHelperTextProps={{
              style: {
                marginTop: "0vh",
              },
            }}
          />
        </div>
        <div className="cat_lis_ad_rs">
          <Button icon={<TfiReload />} iconPosition="start">
            Refresh
          </Button>
          <Button
            className="confirm_btn sub_padding"
            onClick={() => navigate("/admin/add-subcategory")}
          >
            Add Sub-Category
          </Button>
        </div>
      </div>

      <div className="catlis_main">
        {sub_category_all &&
          sub_category_all.map((data, index) => (
            <div className="cat_list_dis_box" key={index}>
              <div className="cat_lst_image_box">
                <img src={data.desktopImage} alt="logo" />
              </div>
              <div className="status_box">
                <h5 className="line_clamp">{data.name}</h5>
                <Switch
                  value={data.status}
                  onChange={(e) => statusChange(e, data)}
                  style={data.status ? { backgroundColor: "#3c9daa" } : {}}
                />
              </div>
              <div className="catdisc ">
                <h5 className="line_1_clamp">{data.name}</h5>
              </div>
              <Link to={`/admin/update-subcategory/${data.slugUrl}`}>
                <div className="edit_cat_ico">
                  <MdEdit />
                </div>
              </Link>
            </div>
          ))}
      </div>
    </>
  );
};

export default SubcategoryList;
